import { createContext } from 'react'
import type { UserFeatureAccess, GlobalToggleName } from '../../services/profile/profileService'

export type FeatureName = 'pdf_export' | 'figma_prompt'

export interface FeatureCheckResult {
  hasAccess: boolean
  tier: 'free' | 'paid'
  showUpgradePrompt: () => void
}

export interface FeatureAccessContextType {
  featureAccess: UserFeatureAccess | null
  loading: boolean
  refetch: () => Promise<void>
  checkFeature: (feature: FeatureName) => FeatureCheckResult
  /** Check if a global feature toggle is enabled (app-wide, not per-tier) */
  isFeatureEnabled: (toggle: GlobalToggleName) => boolean
  upgradeModalVisible: boolean
  blockedFeature: FeatureName | null
  closeUpgradeModal: () => void
  showUpgradeModal: (feature: FeatureName) => void
  onboardingCompleted: boolean
}

export const FeatureAccessContext = createContext<FeatureAccessContextType | undefined>(undefined)
